<template>
<div>
    <sav-fold-card v-if="!warrantyData" v-model="open" :can-open="canOpen" class="mt-4" :close-button="false" :id="$options.name">
        <template v-slot:close></template>
        <template v-slot:open>
            <h1 class="text-xl pt-0.5 font-bold">{{$t('form.garantie.set-case.confirmez_vous_ces_informations')}}</h1>
            <div class="text-sm font-light">{{$t('form.garantie.set-case.vous_devez_confirmer_les_informations_pour_creer_le_dossier')}}</div>
            <hr class="my-3">
            <div class="flex items-center justify-between pb-4 mb-4 border-b">
                <div>
                    <div class="text-sm font-light">Garantie</div>
                    <span class="font-semibold">
                        <span class="break-words">{{ isWarranty ? $t('form.emballage.oui') : $t('form.emballage.non') }}</span>
                    </span>
                </div>
            </div>
            <template v-if="resumeData">
                <div v-for="(obj, objIndex) in resumeData.data" v-bind:key="'data-' + objIndex">
                    <div class="flex items-center justify-between pb-4 mb-4 border-b">
                        <div>
                            <div class="text-sm font-light">{{obj.label}}</div>
                            <span class="font-semibold">
                                <a class="text-blue-500 hover:underline" :href="obj.value.url" v-if="obj.value && checkStringUrl(obj.value.url)" target="_blank">{{$t('form.garantie.set-case.consulter_le_lien')}}</a>
                                <span class="break-words" v-else>{{obj.value}}</span>
                            </span>
                        </div>
                        <button v-if="obj.cardStepName" class="p-2 px-4 text-xs font-light duration-200 border cursor-pointer bg-gray-50 hover:bg-gray-100 rounded-xl" @click="updateCard(obj.cardStepName)">
                            <i class="fas fa-pen"></i>
                        </button>
                    </div>
                </div>
            </template>
            <div v-for="(obj, index) in resumeData.warranty" v-bind:key="'warranty-' + index">
                <div class="flex items-center justify-between pb-4 mb-4 border-b">
                    <div>
                        <div class="text-sm font-light">{{obj.labelSelected || obj.label}}</div>
                        <span class="font-semibold">
                            <a class="text-blue-500 hover:underline" :href="obj.value.url" v-if="obj.value && checkStringUrl(obj.value.url)" target="_blank">{{$t('form.garantie.set-case.consulter_le_lien')}}</a>
                            <span class="break-words" v-else>{{obj.value}}</span>
                        </span>
                    </div>
                    <button v-if="obj.cardStepName" class="p-2 px-4 text-xs font-light duration-200 border cursor-pointer bg-gray-50 hover:bg-gray-100 rounded-xl" @click="updateCard(obj.cardStepName)">
                        <i class="fas fa-pen"></i>
                    </button>
                </div>
            </div>
            <button class="px-5 py-2.5 text-sm font-base text-white duration-100 duration-200 bg-green-600 border-green-700 hover:bg-green-700 rounded-xl" :disabled="loading" @click="end" test-id="btn-submit">
                <small v-if="!loading">
                    <i class="mr-1 fas fa-check"></i> {{$t('form.garantie.set-case.confirmer')}}
                </small>
                <div v-if="loading" class="p-1.5">
                    <sav-spinner color="#fff" :size="8" />
                </div>
            </button>
        </template>
    </sav-fold-card>
    <template v-else>
        <div class="p-6 my-4 bg-white border border-gray-200 shadow my-rounded">
            <div class="flex items-center">
                <i class="mr-3 text-2xl text-green-600 fas fa-check-circle"></i> 
                <div>
                    <h1 class="text-lg font-bold">{{$t('form.garantie.set-case.dossier_enregistre')}}</h1>
                    <h3 class="text-sm font-light">{{$t('form.garantie.set-case.dossier_cree_avec_succes')}}</h3>
                </div>
            </div>
        </div>
    </template>
    <div v-if="warrantyData && warrantyData.process == '0' && warrantyData.texte" class="p-6 my-4 font-bold bg-white border border-gray-200 shadow my-rounded"> {{warrantyData.texte}} </div>
</div>
</template>

<script>
import apiService from '@/services/api.service'
import FormCardExtension from '@/extends/FormCardExtension'
import moment from 'moment'

import eventHub from '@/eventHub'

export default {
    name: 'set-case',
    extends: FormCardExtension,

    watch: {
        open: function (value) {
            // Force open true
            this.open = true
        }
    },

    data() {
        return {
            warrantyData: null,
            caseData: null,
            resumeData: null,
        }
    },

    computed: {
        shopLabel() {
            let endLabel = this.$formTool.getFormData('sign').label

            if (this.$formTool.getFormData('shop')[0].type != 'auto') {
                if (this.$formTool.getFormData('shop')[0].value) {
                    if (this.$formTool.getFormData('shop')[0].value.townAndZipCode) {
                        endLabel += ' ' + this.$formTool.getFormData('shop')[0].value.townAndZipCode
                    }
                } else {
                    if (this.$formTool.getFormData('new-shop')) {
                        endLabel += '- ' + this.$formTool.getFormData('new-shop').ville + ', ' + this.$formTool.getFormData('new-shop').cp
                    } else {
                        endLabel += '- ' + this.$t('form.garantie.shop.lieu_d_achat_introuvable')
                    }
                }
            }
            return endLabel
        },
        isWarranty() {
            let proc = this.$formTool.getFormData('proc')
            if (proc && proc.type_garantie) {
                return proc.type_garantie == "hors_garantie" ? 0 : 1
            }
            return 0
        }
    },

    methods: {
        init() {
            this.open = true

            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.selected = JSON.parse(this.$formTool.getFormData(this.$options.name))
                this.caseData = JSON.parse(this.$formTool.getFormData(this.$options.name + '-case'))
                this.warrantyData = this.selected
                this.nextBlock = this.getNextBlock()
            }

            // Check can open card after set-case
            this.removeOpenAfterSetCase()
            
            // Decrypt all data
            let storageData = JSON.parse(localStorage.getItem('form-data'))
            for (let index in storageData) {
                try {
                    storageData[index] = JSON.parse(this.$crypto.decrypt(storageData[index]))
                }  catch (e) {
                }
            }

            this.resumeData = {
                data: [],
                warranty: storageData['folder-warranty']
            }
            this.resumeData.warranty = this.resumeData.warranty.map((warranty) => ({...warranty, cardStepName: ['folder-warranty']}))

            if (storageData['extension-warranty'] && storageData['extension-warranty'].exists) {
                this.resumeData.data.push({label: this.$t('form.garantie.set-case.numero_d_extension_garantie'), value: storageData['extension-warranty'].number, cardStepName: ['folder-warranty']})
                this.resumeData.data.push({label: this.$t('form.garantie.set-case.justificatif_d_extension_garantie'), value: storageData['extension-warranty'].file, cardStepName: ['folder-warranty']})
            }

            if (storageData['brand']) {
                this.resumeData.data.push({label: this.$t('form.garantie.set-case.produit'), value: (storageData.brand ? storageData.brand.label : '') + (storageData.device ? ((storageData.brand ? ' - ' : '') + storageData.device[0].value['Modele']) : null), cardStepName: ['brand', 'device']})
            }

            if (storageData['code-panne']) {
                this.resumeData.data.push({label: this.$t('form.garantie.set-case.code_panne'), value: storageData['code-panne'].find((item) => item.key == 'description').value + (storageData['code-panne'].find((item) => item.key == 'code_symptome') ? ', ' + storageData['code-panne'].find((item) => item.key == 'code_symptome').value.libelle : '') + (storageData['code-panne'].find((item) => item.key == 'code_condition') ? ', ' + storageData['code-panne'].find((item) => item.key == 'code_condition').value.libelle : ''), cardStepName: ['code-panne']})
            }

            if (storageData['shop']) {
                this.resumeData.data.push({label: this.$t('form.garantie.set-case.vendeur'), value: this.shopLabel, cardStepName: ['shop', 'sign']})
            }

            if (storageData['purchase-date']) {
                this.resumeData.data.push({label: this.$t('form.garantie.set-case.date_d_achat'), value: storageData['purchase-date'][0].value ? this.$formTool.getFormData('purchase-date')[0].value : 'Ne sait pas', cardStepName: ['purchase-date']})
            }

            if (this.$formTool.getFormData('proc').adresse_client.mandatory == '1') {
                this.resumeData.data.push({label: this.$t('form.garantie.set-case.adresse'), value: storageData['client-address'].fullAddress, cardStepName: ['client-address']})
            }

            // Add nameplate-picture
            if (storageData['nameplate-picture']) {
                this.resumeData.data.push({label: this.$t('form.garantie.set-case.plaque_signaletique'), value: storageData['nameplate-picture']})
            }
            
            // Add casino-ticket-picture
            if (storageData['ticket-picture']) {
                this.resumeData.data.push({label: this.$t('form.garantie.set-case.justificatif_d_achat'), value: storageData['ticket-picture']})
            }
        },
        async end() {
            this.loading = true

            let client_id = this.$crypto.decrypt(localStorage.getItem('client_id'))
            let fileInvoicePicture = this.$formTool.getFormData('casino-ticket-picture') ? this.$formTool.getFormData('casino-ticket-picture')[0] : this.$formTool.getFormData('folder-warranty').find(item => item.key === 'invoicePicture')
            let filePlaque = this.$formTool.getFormData('nameplate-picture') ? this.$formTool.getFormData('nameplate-picture')[0] : this.$formTool.getFormData('folder-warranty').find(item => item.key === 'PlaquePicture')
            let chooseProcess = this.$formTool.getFormData('choose-process')

            let response = await apiService.post('setcase', {
                purchase_date: this.$formTool.getFormData('purchase-date')[0].value ? moment(this.$formTool.getFormData('purchase-date')[0].value, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
                id_app: this.$formTool.getFormData('device')[0].value.id,
                id_mag: this.$formTool.getFormData('shop') && this.$formTool.getFormData('shop')[0] && this.$formTool.getFormData('shop')[0].value ? this.$formTool.getFormData('shop')[0].value.id : 1,
                nom_mag: this.$formTool.getFormData('new-shop') && this.$formTool.getFormData('new-shop').ville ? this.$formTool.getFormData('new-shop').ville : null,
                cp_mag: this.$formTool.getFormData('new-shop') && this.$formTool.getFormData('new-shop').cp ? this.$formTool.getFormData('new-shop').cp : null,
                pays_mag: this.$formTool.getFormData('new-shop') && this.$formTool.getFormData('new-shop').pays ? this.$formTool.getFormData('new-shop').pays.name : null,
                nom_enseigne: this.$formTool.getFormData('sign') && !this.$formTool.getFormData('sign').id && !this.$formTool.getFormData('sign').ecommerce ? this.$formTool.getFormData('sign').label : null,
                nom_site: this.$formTool.getFormData('sign') && !this.$formTool.getFormData('sign').id && this.$formTool.getFormData('sign').ecommerce ? this.$formTool.getFormData('sign').label : null,
                id_proc: this.$formTool.getFormData('id_proc'),
                serial_number: this.$formTool.getFormData('folder-warranty').find(item => item.key === "serialNumber") ? this.$formTool.getFormData('folder-warranty').find(item => item.key === "serialNumber").value : '',
                tel_client: this.$formTool.getFormData('folder-warranty').find(item => item.key === "tel_client") ? this.$formTool.getFormData('folder-warranty').find(item => item.key === "tel_client").value : null,
                invoice_num: this.$formTool.getFormData('folder-warranty').find(item => item.key === "invoiceNumber") ? this.$formTool.getFormData('folder-warranty').find(item => item.key === "invoiceNumber").value : null,
                datefab: this.$formTool.getFormData('folder-warranty').find(item => item.key === "fabricationDate") ? this.$formTool.getFormData('folder-warranty').find(item => item.key === "fabricationDate").value : null,
                num_commande: this.$formTool.getFormData('folder-warranty').find(item => item.key === "numCommande") ? this.$formTool.getFormData('folder-warranty').find(item => item.key === "numCommande").value : null,
                num_cmd: this.$formTool.getFormData('num_cmd') ? this.$formTool.getFormData('num_cmd') : null,
                description: this.$formTool.getFormData('code-panne') ? this.$formTool.getFormData('code-panne').find((item) => item.key == 'description').value : null,
                code_symptome: this.$formTool.getFormData('code-panne') && this.$formTool.getFormData('code-panne').find((item) => item.key == 'code_symptome') ? this.$formTool.getFormData('code-panne').find((item) => item.key == 'code_symptome').value.code : null,
                code_condition: this.$formTool.getFormData('code-panne') && this.$formTool.getFormData('code-panne').find((item) => item.key == 'code_condition') ? this.$formTool.getFormData('code-panne').find((item) => item.key == 'code_condition').value.code : null,
                id_conso: client_id,
                id_file: fileInvoicePicture && fileInvoicePicture.value ? fileInvoicePicture.value.id : null,
                id_photo: this.$formTool.getFormData('folder-warranty').find(item => item.key === 'failurePicture') && this.$formTool.getFormData('folder-warranty').find(item => item.key === 'failurePicture').value ? this.$formTool.getFormData('folder-warranty').find(item => item.key === 'failurePicture').value.id : null,
                id_plaque: this.$formTool.getFormData('folder-warranty').find(item => item.key === 'failurePicture') && this.$formTool.getFormData('folder-warranty').find(item => item.key === 'failurePicture').value ? this.$formTool.getFormData('folder-warranty').find(item => item.key === 'failurePicture').value.id : null,
                indicesav: this.$formTool.getFormData('folder-warranty').find(item => item.key === 'indiceSav') && this.$formTool.getFormData('folder-warranty').find(item => item.key === 'indiceSav').value ?  this.$formTool.getFormData('folder-warranty').find(item => item.key === 'indiceSav').value : null,
                id_plaque: filePlaque && filePlaque.value ? filePlaque.value.id : null,
                quizz_image: this.$formTool.getFormData('quizz_image') ? this.$formTool.getFormData('quizz_image').id : null,
                num_extension: this.$formTool.getFormData('extension-warranty') && this.$formTool.getFormData('extension-warranty').exists ? this.$formTool.getFormData('extension-warranty').number : null,
                id_file_extension: this.$formTool.getFormData('extension-warranty') && this.$formTool.getFormData('extension-warranty').exists ? this.$formTool.getFormData('extension-warranty').file.id : null,
                online: this.$formTool.getFormData('buy-online') && this.$formTool.getFormData('buy-online') == 'online' ? 1 : 0,
                comment: chooseProcess && chooseProcess.comment ? chooseProcess.comment : '',
                process_choice: chooseProcess ? chooseProcess.process : ''
            })

            if (response.data.posts.post.id_case && this.$formTool.getFormData('tchat-history')) {
                let responseTchatHistory = await apiService.post('setchatbot', {
                    chatbot: JSON.stringify(this.$formTool.getFormData('tchat-history')),
                    id_case: response.data.posts.post.id_case
                })
            }

            // Break if error in setcase
            if (response.data.posts.error) {
                this.loading = false
                return
            }
            let responseCase = await apiService.post('getdetailcase', {
                id_case: response.data.posts.post.id_case
            })
            this.caseData = responseCase.data.posts.post

            this.$formTool.addFormData(this.$options.name, JSON.stringify(response.data.posts.post))
            this.$formTool.addFormData(this.$options.name + '-case', JSON.stringify(this.caseData))
            this.warrantyData = response.data.posts.post

            if (this.warrantyData.process == '0') {
                this.warrantyData.texte = await apiService.text('set_case_no_process', this.$formTool.getFormData('proc').id, this.warrantyData.id_case)
            }

            this.nextBlock = this.getNextBlock()

            if (this.selected) {
                this.$emit('update', this.$options.name)
            }

            this.emitChange()

            eventHub.$emit('set-setcase')

            this.loading = false
        },

        getNextBlock() {
            if (this.warrantyData) {
                if (this.warrantyData.process == 'Echange') {
                    return this.$formTool.blockData(this.$options.name).next.echange
                }
                if (this.warrantyData.process == 'iad') {
                    return this.$formTool.blockData(this.$options.name).next.iad
                }
                if (this.warrantyData.process == 'sav') {
                    return this.$formTool.blockData(this.$options.name).next.sav
                }
                if (this.warrantyData.process == 'direct') {
                    return this.$formTool.blockData(this.$options.name).next.direct
                }
                if (this.warrantyData.process == '0') {
                    return this.$formTool.blockData(this.$options.name).next.end
                }
            }
        },

        checkStringUrl(string) {
            let url;

            if (!string)
                return false
            
            try {
                url = new URL(string);
            } catch (_) {
                return false;  
            }

            return url.protocol === "http:" || url.protocol === "https:";
        },

        updateCard(cardNames) {
            eventHub.$emit('close-all-cards', ['set-case'])

            this.$nextTick(() => {
                const yOffset = -100;
                for (const key in cardNames) {
                    const element = document.querySelector(".form-card[keyname='" + cardNames[key] + "']");
                    if (element) {
                        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                        window.scrollTo({top: y, behavior: 'smooth'});
                        eventHub.$emit('open-card', cardNames[key])
                        break
                    }
                }
            })
        }
    },

    filters: {
        moment(date) {
            return moment(date).format('DD/MM/YYYY');
        },
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/warranty/SetCaseCard.vue